import * as React from 'react';
import { Link } from 'react-router-dom';
import { Variant, Dimensions } from '../product';

export interface VariantListItemProps {
  variant: Variant;
}

const indicatorClasses = (active: boolean) => {
  return `db w1 h1 br-100 bg-${active ? 'green' : 'red'}`;
};

const formatDimensions = (val: Dimensions) => {
  return `${val.width}${val.unit} x ${val.height}${val.unit} x ${val.depth}${
    val.unit
  }`;
};

export default function VariantListItem(props: VariantListItemProps) {
  return (
    <div className="flex justify-between items-center pa2 pa3-ns ph4-ns bb b--black-10">
      <div className="mr4">
        <div className={indicatorClasses(props.variant.in_stock)} />
      </div>
      <div className="">
        <h4 className="lh-title ma0 mb2">{props.variant.name}</h4>
        <p className="lh-copy ma0 f6 black-50 truncate">
          {props.variant.description_text}
        </p>
      </div>
      <div className="ph2 ph3-ns">
        <p className="lh-copy ma0 mb2 f6 black-50">Weight</p>
        {props.variant.weight} {props.variant.weight_unit}
      </div>
      <div className="ph2 ph3-ns">
        <p className="lh-copy ma0 mb2 f6 black-50">Dimensions (W x H x D)</p>
        {formatDimensions(props.variant.dimensions)}
      </div>
      <div className="ph2 ph3-ns">
        <p className="lh-copy ma0 mb2 f6 black-50">Stock Count</p>
        {props.variant.stock_count}
      </div>
      <div className="ph2 ph3-ns">
        <p className="lh-copy ma0 mb2 f6 black-50">Stock Policy</p>
        {props.variant.stock_policy}
      </div>
      <div className="ph2 ph3-ns">
        <p className="lh-copy ma0 mb2 f6 black-50">Price</p>
        {(props.variant.price.value / 100).toFixed(2)}{' '}
        {props.variant.price.currency}
      </div>
      <div className="pl3">
        <Link
          to={{
            pathname: `/products/${props.variant.product_id}/variants/${
              props.variant.id
            }`,
            state: {
              variant: props.variant,
            },
          }}
          className="link black underline b"
        >
          Add Stock
        </Link>
      </div>
      <div className="pl3">
        <Link
          to={{
            pathname: `/products/${props.variant.product_id}/variants/${
              props.variant.id
            }`,
            state: {
              variant: props.variant,
            },
          }}
          className="link black underline b"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
